import { useEffect } from 'react';
import { fetchAdmin, toErrorMessage } from '../../admin/api';
import { fDateTime } from '../../utils/formatTime';
import { AdminDataTable } from '../../sections/admin/shared';
import { AdminRouteLayout, RequestState, useAsyncState } from './AdminRoutePageShared';

export default function AccessControlAuditPage() {
  const audit = useAsyncState([]);

  useEffect(() => {
    const load = async () => {
      audit.setLoading();
      try {
        const response = await fetchAdmin('/access/audit');
        audit.setData(response.items || []);
      } catch (error) {
        audit.setError(toErrorMessage(error));
      }
    };

    load();
  }, []);

  return (
    <AdminRouteLayout title="Audit" breadcrumbTitle="Access Control">
      <RequestState loading={audit.state.loading} error={audit.state.error}>
        <AdminDataTable
          title="Access Audit"
          description="Governance audit records emitted by backend access enforcement."
          columns={[
            { field: 'staffId', headerName: 'Staff ID' },
            { field: 'permission', headerName: 'Permission' },
            { field: 'action', headerName: 'Action' },
            { field: 'result', headerName: 'Result' },
            { field: 'createdAt', headerName: 'Created' },
          ]}
          rows={(audit.state.data || []).map((row) => ({
            id: row.id,
            staffId: row.staff_id,
            permission: row.permission_code,
            action: row.action,
            result: row.result,
            createdAt: fDateTime(row.created_at),
          }))}
          emptyTitle="No audit records"
          emptyDescription="The access audit endpoint returned no audit activity rows."
        />
      </RequestState>
    </AdminRouteLayout>
  );
}
